import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TUserClientContact, TUserClientContactPayloadUpdate, TUserClientContactResponse, adaptUserClientContactFromResponse, adaptUserClientContactToRequest } from '../../types';
import { useAppSelector } from '../../hooks';
import { BACKEND_USER_CLIENT } from '../../backend-paths';


export const userClientContactUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_USER_CLIENT}/:client_id/contacts/:id`,
	(payload: TUserClientContactPayloadUpdate, thunkApi) => {
		const { id, clientId, data } = payload;
		const path = `${BACKEND_USER_CLIENT}/${clientId}/contacts/${id}`;
		const dataRequest = adaptUserClientContactToRequest(data);

		return HttpService.put<TUserClientContactResponse>(path, dataRequest).then(result => {
			return adaptUserClientContactFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	item: TUserClientContact | undefined,
	isLoading: boolean,
	error?: HttpError,
};

const initialState: TInitialState = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userClientContactUpdateSlice = createSlice({
	name: 'userClientContactUpdateSlice',
	initialState,
	reducers: {
		clearUserClientContactUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userClientContactUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[userClientContactUpdateApi.fulfilled.type]: (state, action: PayloadAction<TUserClientContact>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userClientContactUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useUserClientContactUpdateSelector = () => useAppSelector(state => state[userClientContactUpdateSlice.name]);

export const { clearUserClientContactUpdate } = userClientContactUpdateSlice.actions;
